export default function UniversityCardSkeleton() {
  return (
    <div
      className="card-flat h-full flex flex-col gap-5 bg-white/60 p-4 sm:p-5 animate-pulse"
      aria-hidden="true"
    >
      <div className="rounded-xl bg-paper-deep aspect-[16/9]" />
      <div className="flex flex-col gap-5 flex-1 px-2 pb-2 sm:px-2.5 sm:pb-2.5">
        <div className="flex flex-col gap-3">
          <div className="h-6 w-3/4 rounded-md bg-paper-deep" />
          <div className="flex gap-4">
            <div className="h-4 w-20 rounded bg-paper-deep" />
            <div className="h-4 w-24 rounded bg-paper-deep" />
            <div className="h-4 w-16 rounded bg-paper-deep" />
          </div>
        </div>
        <div className="rounded-xl h-44 bg-paper-deep/50" />
        <div className="mt-auto h-[46px] rounded-xl bg-paper-deep" />
      </div>
    </div>
  );
}
